import React, { FC } from 'react'
import imgSrc from '../../assets/errors/404.svg'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { Text } from './styled'
import { history } from '../../store'
import { PAGE_DASHBOARD, PAGE_LOGIN } from '../../constants/navigation'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { selectAuthStatus } from '../../store/reducers/auth/selectors'

const Error404: FC = () => {
	const isAuth = useTypedSelector(selectAuthStatus)

	const handleClick = (): void => {
		const path = isAuth ? PAGE_DASHBOARD : PAGE_LOGIN

		history.replace(path)
	}

	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			alignItems={'center'}
			maxWidth={'20rem'}
			minWidth={'14.5rem'}
		>
			<img src={imgSrc} alt={''} loading={'lazy'} width={232} />

			<Text paragraph mb={5.1} mt={5.5}>
				Oops... We can not find this page
			</Text>

			<Button
				size={'large'}
				variant='contained'
				color={'primary'}
				sx={{ maxWidth: '10rem' }}
				onClick={handleClick}
			>
				Take me home
			</Button>
		</Box>
	)
}

export default Error404
